<template>
  <div v-if="isFavoritPOI()">
    <button @click="toggle" class="border border-gray-400 focus:outline-none rounded h-8 w-8 p-1 rounded-full" :disabled="loading">
      <template v-if="loading">
        <svg class="animate-spin h-5 w-5 text-gray-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </template>
      <template v-else>
        <svg v-if="on" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
          <path d="M11 4.22l-.61-.6c-2.1626-2.045-5.5596-1.9987-7.6656.1046C.6184 5.8278.5677 9.2248 2.61 11.39L11 19.78l8.39-8.4c2.0423-2.1652 1.9916-5.5622-.1144-7.6654-2.106-2.1033-5.503-2.1497-7.6656-.1046l-.61.61z" fill="#FF4156" fill-rule="nonzero" stroke="#FF4156" stroke-width=".5"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
          <path d="M11 4.22l-.61-.6c-2.1626-2.045-5.5596-1.9987-7.6656.1046C.6184 5.8278.5677 9.2248 2.61 11.39L11 19.78l8.39-8.4c2.0423-2.1652 1.9916-5.5622-.1144-7.6654-2.106-2.1033-5.503-2.1497-7.6656-.1046l-.61.61z" stroke="#979797" stroke-width="1" fill="none" fill-rule="evenodd"/>
        </svg>
      </template>
    </button>
  </div>
</template>

<script>
import Constants from '../../constants'

export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    on: function () {
      return this.$store.getters['favorites/isOn'](this.place)
    }
  },
  methods: {
    toggle: function () {
      this.loading = true
      const favoriteGenre = this.$store.getters['genres/getFavoriteGenre']
      if (this.on) {
        if (favoriteGenre !== undefined) {
          this.$store.dispatch('places/updateFavoritePlace', { id: this.place.id, favoriteId: favoriteGenre.id, favorited: false })
        }
        this.$store.dispatch('favorites/delete', this.place)
          .catch(() => {
            const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
            this.$alert({ message: this.$t('tour_login_error_message') + '<p><a href="' + Constants.LINK_BASE_URL_LIST[env_key] + '" class="break-all text-link">' + this.$t('tour_tohoku_maas_link') + '</a></p>' })
          })
          .finally(() => this.loading = false)
      } else {
        if (favoriteGenre !== undefined) {
          this.$store.dispatch('places/updateFavoritePlace', { id: this.place.id, favoriteId: favoriteGenre.id, favorited: true })
        }
        this.$store.dispatch('favorites/create', this.place)
          .catch(() => {
            const env_key = process.env.VUE_APP_LINK_BASE_ENV || process.env.NODE_ENV
            this.$alert({ message: this.$t('tour_login_error_message') + '<p><a href="' + Constants.LINK_BASE_URL_LIST[env_key] + '" class="break-all text-link">' + this.$t('tour_tohoku_maas_link') + '</a></p>' })
          })
          .finally(() => this.loading = false)
      }
    },
    isFavoritPOI: function () {
      if (isNaN(this.place.id)) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
